import React, { useCallback, useContext, useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import "../../src/assets/AdminCss/cricket.css";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { AuthContext, base_url } from "../context/Authcontext";
import toast from "react-hot-toast";
import LoginReg from "./LoginReg";
import CricketScoreboard from "./CricketScoreboard";
import TennisScoreboard from "./TennisScoreboard";
import { useTheme } from "../context/ThemeContext";
import MarqueeBottom from "./components/MarqueeBottom";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Button, Modal, Space } from "antd";
import Offcanvas from "react-bootstrap/Offcanvas";
import GameButtons from "./components/GameButtons";

const Tennis = () => {
  const [isSidebar, setSidebar] = useState(false);
  const location = useLocation();
  const [back1, setBack1] = useState([]);
  const [lay1, setLay1] = useState([]);
  const [back2, setBack2] = useState([]);
  const [lay2, setLay2] = useState([]);
  const [backActive, setbackActive] = useState(0);
  const [layActive, setlayActive] = useState(3);
  const [profit, setProfit] = useState(0);
  const [pr, setPr] = useState(0);
  const [active, setActive] = useState(false);
  const { themeColors } = useTheme();
  const { userdata } = useContext(AuthContext);

  const [side, setSide] = useState("");
  const [oddsDelay, setOddsDelay] = useState();
  const [matchLiabilities, setMatchLiabilities] = useState();
  const [oddMatchLiablity, setOddMatchLiablity] = useState();

  const [selectedPrice, setSelectedPrice] = useState();
  const [money, setMoney] = useState(0);
  const { isAuthenticated } = useContext(AuthContext);

  const [marketId, setMarketId] = useState(() => {
    return location.state?.marketId || sessionStorage.getItem("marketId") || "";
  });

  const [runner1, setRunner1] = useState(() => {
    return location.state?.runner1 || sessionStorage.getItem("runner1") || "";
  });

  const [runner2, setRunner2] = useState(() => {
    return location.state?.runner2 || sessionStorage.getItem("runner2") || "";
  });
  const [runner3, setRunner3] = useState(() => {
    return location.state?.runner3 || sessionStorage.getItem("runner3") || "";
  });

  const [selectedId, setSelectedId] = useState(0);
  const [runner, setRunner] = useState("");

  const competiton = sessionStorage.getItem("competitionname");
  const event = sessionStorage.getItem("eventname");
  const selectionid1 = sessionStorage.getItem("selectionid1");
  const selectionid2 = sessionStorage.getItem("selectionid2");
  const selectionid3 = sessionStorage.getItem("selectionid3");

  const eventId = sessionStorage.getItem("eventid");
  const [startTime, setStartTime] = useState();

  const [channel, setChannel] = useState();
  const [betData, setBetData] = useState([]);
  const [play, setPlay] = useState(false);
  const [minOdds, setMinOdds] = useState(0);
  const [maxOdds, setMaxOdds] = useState(0);
  const [unmatch, setUnmatch] = useState([]);

  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 991);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showV, setShowV] = useState(false);
  const handleCloseV = () => setShowV(false);
  const handleShowV = () => setShowV(true);

  const [gameButtons, setGameButtons] = useState([]);
  const handleButtonsChange = (updatedButtons) => {
    setGameButtons(updatedButtons);
    console.log("Buttons in Cricket.js:", updatedButtons);
  };

  const [showCanvas, setShowCanvas] = useState(false);

  const handleCanvasShow = () => setShowCanvas(true);
  const handleCanvasClose = () => setShowCanvas(false);

  const [open, setOpen] = useState(false);
  const showModal = () => {
    setOpen(true);
  };
  const hideModal = () => {
    setOpen(false);
  };

  // bet form data
  const [formData, setFormData] = useState({
    competiton: competiton,
    eventname: event,
    eventid: 0,
    marketId: marketId,
    selectionId: 0,
    runnername: "",
    betPrice: 0,
    type: "odds",
    betAmount: 0,
    profit: 0,
    side: side,
    sportName: "tennis",
    team1: runner1,
    team2: runner2,
  });

  // console.log('selec',selectedMarket);

  // console.log('iidd',marketId);

  function formatDate(isoString) {
    const date = new Date(isoString);
    return date.toLocaleString("en-US", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  }

  function isTenMinutesRemaining(isoString) {
    const targetTime = new Date(isoString).getTime(); // Convert given time
    const currentTime = new Date().getTime(); // Get current time

    // Calculate the difference in milliseconds
    const timeDifference = targetTime - currentTime;

    // Convert milliseconds to minutes
    const minutesRemaining = timeDifference / (1000 * 60);

    return minutesRemaining > 10;
  }

  function convertDecimalToInteger(decimalValue) {
    // Get the integer part
    const integerPart = Math.floor(decimalValue);

    // Get the decimal part
    const decimalPart = decimalValue - integerPart;

    // Apply the rule
    if (decimalPart >= 0.5) {
      return integerPart + 1; // Round up
    } else {
      return integerPart; // Round down
    }
  }

  const handleChange = (action) => {
    console.log("act", action);

    setMoney((prevMoney) => {
      let newMoney = prevMoney < 0 ? 0 : prevMoney;

      if (action === 0) {
        return Math.max(0, parseFloat(newMoney) - 100);
      } else {
        return parseFloat(newMoney) + 100;
      }
    });
  };

  const handlelayChange = (action) => {
    setSelectedPrice((prev) => {
      let newMoney = prev < 1.01 ? 1.01 : prev;

      if (action === 0) {
        return Math.max(0, (parseFloat(newMoney) - 0.01).toFixed(2));
      } else {
        return (parseFloat(newMoney) + 0.01).toFixed(2);
      }
    });
  };

  useEffect(() => {
    const getTimeDelay = async () => {
      try {
        const response = await axios.get(
          base_url + "/get/api/webapi/sportsData/timeDelay",
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json",
            },
          }
        );
        if (response?.data.success) {
          if (response?.data?.betDelay?.length > 0) {
            let timeDelayData = response?.data.betDelay;
            const delays = timeDelayData[0] || "";

            const oddss = JSON.parse(delays?.match_odds_tennis);
            const oddsDelay = oddss?.bet_delay || 0;
            const minBet = oddss?.min_bet || 0;
            const maxBet = oddss?.max_bet || 0;
            // console.log(minBet);
            setMinOdds(minBet);
            setMaxOdds(maxBet);
            setOddsDelay(oddsDelay * 1000);
          }
        }
      } catch (err) {
        console.log(err);
      }
    };

    getTimeDelay();
  }, []);

  const betData1 = async () => {
    try {
      const response = await axios.post(
        base_url + "/api/webapi/betData",
        { eventId },
        {
          withCredentials: true,
          headers: {
            "content-type": "application/json",
          },
        }
      );

      // console.log('databet',response);

      if (response?.data.success) {
        const data = response?.data.sportsBets;
        const unmach = response?.data.unmatch;
        // console.log('ddd',data);
        setBetData(data);
        setUnmatch(unmach);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // formdata odds
  const handleSubmit = async () => {
    if (!isAuthenticated) {
      setActive(true);
      return;
    }
    // if(isTenMinutesRemaining(startTime)){
    //   toast.error('Off Bets! Bets placed only before ten minutes');
    //   return;
    // }

    if (money < minOdds) {
      toast.error("Bet cant be placed less than min value");
      return;
    }
    if (money > maxOdds) {
      toast.error("Bet cant be placed greater than max value");
      return;
    }

    if (selectedPrice < 1) {
      toast.error("Bet selectedprice is less");
      return;
    }

    // ✅ Ensure `oddsDelay` has a valid value
    const delay = oddsDelay || 0;

    setTimeout(async () => {
      if (side === "Back") {
        const allBackPrices = [...back1, ...back2];

        const valuee = allBackPrices.some((bac) => bac.price === selectedPrice);

        if (!valuee) {
          try {
            const response = await axios.post(
              base_url + "/api/webapi/unmatched",
              formData,
              {
                withCredentials: true,
                headers: {
                  "content-type": "application/json",
                },
              }
            );

            if (response?.data.success) {
              toast.error("Bet placed to unmatched due to value change");
              betData1();
          
            }
          } catch (err) {
            console.log(err);
          }

          return;
        }
      }

      if (side === "Lay") {
        const allLayPRices = [...lay1, ...lay2];
        const values = allLayPRices.some((lay) => lay.price === selectedPrice);

        if (!values) {
          try {
            const response = await axios.post(
              base_url + "/api/webapi/unmatched",
              formData,
              {
                withCredentials: true,
                headers: {
                  "content-type": "application/json",
                },
              }
            );

            if (response?.data.success) {
              toast.error("Bet placed to unmatched due to value change");
              betData1();
                  userdata();
            }
          } catch (err) {
            console.log(err);
          }

          return;
        }
      }

      try {
        const response = await axios.post(
          base_url + "/api/webapi/sportsData",
          formData,
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json",
            },
          }
        );

        // console.log('formmatch',response);

        if (response?.data.success) {
          toast.success(response?.data.message);
          betData1();
        } else {
          toast.error(response?.data.message);
        }
      } catch (err) {
        console.log(err);
        toast.error("Failed to place bet");
      }
    }, delay);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setSidebar(true);
      } else {
        setSidebar(false);
      }
    };

    if (location.state?.marketId) {
      sessionStorage.setItem("marketId", location.state.marketId);
      setMarketId(location.state.marketId);
    }

    if (location.state?.runner1) {
      sessionStorage.setItem("runner1", location.state.runner1);
      setRunner1(location.state.runner1);
    }

    if (location.state?.runner2) {
      sessionStorage.setItem("runner2", location.state.runner2);
      setRunner2(location.state.runner2);
    }

    if (location.state?.runner3) {
      sessionStorage.setItem("runner3", location.state.runner3);
      setRunner3(location.state.runner3);
    }

    const liveTv = async () => {
      try {
        const response = await axios.get(base_url + "/api/webapi/liveTv");
        const live = response?.data.result;
        const matchedData = live.filter(
          (item) => item.MatchID === parseFloat(eventId)
        );
        const channel = matchedData[0].Channel;

        // Get the TV URL from your API
        const respone = await axios.post(base_url + "/api/webapi/tv/channel", {
          channel,
        });
        const tvLink = respone?.data.message;

        // Set the full URL with proper encoding
        setChannel(encodeURI(tvLink));
      } catch (err) {
        console.log(err);
      }
    };

    const proft =
      parseFloat(selectedPrice) * parseFloat(money) - parseFloat(money);
    setProfit(proft.toFixed(1));

    // console.log('prff',proft);
    // Add event listener for resize
    window.addEventListener("resize", handleResize);
    handleResize();

    liveTv();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
      // sessionStorage.clear();
    };
  }, [location.state, money, selectedPrice]);

  useEffect(() => {
    window.scrollTo(0, 0);

     const backLay = async () => {
       console.log("fetching backlay data for marketId:", marketId);
       try {
         const response = await axios.get(
           base_url + `/api/webapi/market/${marketId}`,
           {
             headers: {
               "Content-Type": "application/json",
             },
           }
         );
 console.log("backlayresponse", response);
 
         const status1 = response?.data.result[0]?.status;
         const status2 = response?.data.result[1]?.status;
         // console.log("wkjenkfjebnrjg", status1);
         // console.log("2kjrk,befgrhkgyuf", status2);
 
         if (status1 === "ACTIVE") {
           const backk1 = response?.data.result[0]?.ex?.availableToBack;
           const layy1 = response?.data.result[0]?.ex?.availableToLay;
 
           setBack1(backk1);
           setLay1(layy1);
         }
 
         if (status2 === "ACTIVE") {
           const backk2 = response?.data.result[1]?.ex?.availableToBack;
           const layy2 = response?.data.result[1]?.ex?.availableToLay;
 
           setBack2(backk2);
           setLay2(layy2);
         }
       } catch (err) {
         console.log("Error fetching in odds data", err);
       }
     };

    const sessiontime = sessionStorage.getItem("time");
    const time = formatDate(sessiontime);
    // console.log('time',time);
    setStartTime(time);

    const updateData = () => {
      backLay();
    };

    betData1();

    const intervalId = setInterval(updateData, 1000);

    // Cleanup function to clear interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  // console.log('matchess',wpMarket);

  // betformdata
  formData.selectionId = selectedId;
  formData.runnername = runner;
  formData.betAmount = money;
  formData.profit = profit;
  formData.eventid = eventId;
  formData.betPrice = selectedPrice;
  formData.side = side;

  const calculatePnLByMarket = (bets, team1, team2) => {
    const marketTypes = ["odds", "bookmaker", "mini_bookmaker"];
    const result = {};

    marketTypes.forEach((market) => {
      const marketBets = bets?.filter((b) => {
        const betType = b?.type
          ?.toString()
          .trim()
          .toLowerCase()
          .replace(/\s+/g, "");
        return betType === market;
      });

      // console.log(market, marketBets, "fev");

      const runnerPnl = {};

      // Collect unique runners
      const runners = new Set(marketBets.map((b) => b.runnerName));
      runners.add(team1);
      runners.add(team2);
      // Check if runner3 (i.e., "The Draw") exists in sessionStorage
      const runner3 = sessionStorage.getItem("runner3");
      if (runner3 && runner3.toLowerCase() === "the draw") {
        runners.add("The Draw");
      }

      // Initialize PnL
      for (const runner of runners) {
        runnerPnl[runner] = 0;
      }

      // Calculate PnL
      marketBets?.forEach(({ runnerName, side, betprice, betAmount }) => {
        const odds = parseFloat(betprice);
        const stake = parseFloat(betAmount);

        for (const currentRunner of runners) {
          if (marketBets[0].type === "book maker") {
            if (currentRunner === runnerName) {
              if (side === "Back") {
                runnerPnl[currentRunner] += (stake * odds) / 100;
              } else if (side === "Lay") {
                runnerPnl[currentRunner] -= (stake * odds) / 100;
              }
            } else {
              if (side === "Back") {
                runnerPnl[currentRunner] -= stake;
              } else if (side === "Lay") {
                runnerPnl[currentRunner] += stake;
              }
            }
          } else {
            if (currentRunner === runnerName) {
              if (side === "Back") {
                runnerPnl[currentRunner] += (odds - 1) * stake;
              } else if (side === "Lay") {
                runnerPnl[currentRunner] -= (odds - 1) * stake;
              }
            } else {
              if (side === "Back") {
                runnerPnl[currentRunner] -= stake;
              } else if (side === "Lay") {
                runnerPnl[currentRunner] += stake;
              }
            }
          }
        }
      });

      // Round to 2 decimal places
      Object.keys(runnerPnl).forEach((runner) => {
        runnerPnl[runner] = parseFloat(runnerPnl[runner].toFixed(2));
      });

      // Calculate liability (worst case)
      const liability = Object.values(runnerPnl).length
        ? Math.min(...Object.values(runnerPnl))
        : 0;

      result[market] = {
        pnl: runnerPnl,
        liability: parseFloat(liability.toFixed(2)),
      };
    });

    return result;
  };

  const getMatchLiabilities = async () => {
    try {
      const response = await axios.get(
        `${base_url}/api/webapi/getMatchLiablity/${eventId}`,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      const bets = response.data.liabilities || []; // ✅ fix here

      // console.log(bets, "bets after fix");

      const { team1, team2 } = bets[0] || {};

      const result = calculatePnLByMarket(bets, team1, team2);

      setMatchLiabilities(result);
    } catch (error) {
      console.error("Error fetching match liabilities:", error);
    }
  };

  useEffect(() => {
    getMatchLiabilities();
  });

  return (
    <>
      {/* {<LoginReg active={active} setactive={setActive} />} */}
      <app-root _nghost-jrx-c101="" ng-version="12.2.16">
        <div _ngcontent-jrx-c101="" className="rightbar">
          <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
            <div _ngcontent-jrx-c95="" className="head-container">
              <Header
                isSidebar={isSidebar}
                setSidebar={setSidebar}
                show={showCanvas}
                handleShow={handleCanvasShow}
                handleClose={handleCanvasClose}
              />
              <div _ngcontent-jrx-c95="" className="body-container">
                <div className="d-none d-md-flex d-xl-flex">
                  <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
                </div>

                <div
                  _ngcontent-jrx-c95=""
                  className="rightbar d-flex flex-column"
                  style={{
                    width: isSidebar ? "" : "2500%",
                    transition: "width 0.3s ease-in-out",
                  }}
                >
                  <div className="d-flex flex-column flex-lg-row justify-content-between mainn w-100 ">
                    <div
                      className="match-content"
                      style={{
                        backgroundColor:
                          themeColors["--dark-theme-color-navbar"],
                      }}
                    >
                      <div className="scoreboard-header d-dlex">
                        <div>
                          {competiton} {event}
                        </div>
                        <div className="ms-auto">{startTime}</div>
                      </div>
                   
                <iframe
  title="Live TV"
  className="border w-100 "
  src={`https://score.tresting.com/socket-iframe-1/crickexpo/${channel}`}
  style={{ width: "100%", height: "297px" }}
/>

                      <div
                        className="match-section mb-1 mt-xl-2 mt-0"
                        style={{
                          color: themeColors["--dark-theme-color-navbar"],
                        }}
                      >
                        <div
                          className="match-header align-items-end h-auto"
                          style={{ borderBottom: "1px solid #d3cece" }}
                        >
                          <div
                            style={{
                              backgroundColor: themeColors["--bg-secondary85"],
                              marginTop: "0px",
                              padding: "5px 10px",
                            }}
                            className="d-flex mb-0 flex-lg-row flex-row flex-md-row align-items-baseline"
                          >
                            <p
                              style={{
                                color: themeColors["--dark-theme-color-navbar"],
                              }}
                              className=" me-3 d-flex fw-bold mb-0 rad bett"
                            >
                              Match odds
                            </p>
                            {/* <p
                              className="btn mt-0 btn-success py-1 rounded-0 disabled ms-auto"
                            >
                              Cashout
                            </p> */}
                          </div>

                          <div
                            className="d-flex"
                            style={{
                              height: "2.1rem",
                              marginRight: isLargeScreen ? "7.9rem" : "0rem",
                            }}
                          >
                            <p
                              className="d-flex gap-1 fs-7 ps-2 me-5 my-auto mb-0 fszz fw-bold"
                              style={{ color: themeColors["--text-info"] }}
                            >
                              <span
                                className="fw-bold"
                                style={{ color: themeColors["--text-info"] }}
                              >
                                Min:{minOdds} <span>|</span>{" "}
                              </span>{" "}
                              Max:{maxOdds}
                            </p>
                            <p
                              className="fs-6 mb-0 px-0  ms-auto bgInfo text-center"
                              style={{ border: "1px solid #c1bdbd" }}
                            >
                              Back
                            </p>
                            <p
                              className="fs-6 px-xl-3 px-0 mb-0 bg-pink1"
                              style={{ border: "1px solid #c1bdbd" }}
                            >
                              Lay
                            </p>
                          </div>
                        </div>

                        <div className="betting-options d-flex flex-column">
                          <div
                            style={{ borderBottom: "1px solid #d3cece" }}
                            className="betting-row d-flex flex-md-row justify-content-between align-items-center border-2 p-0"
                          >
                            <h5
                              className="my-auto fs-4 text-wrap run ps-2 m-0"
                              id={selectionid1}
                              style={{ color: themeColors["--text-table"] }}
                            >
                              {runner1}{" "}
                              <span
                                className={`${
                                  (matchLiabilities?.odds?.pnl?.[runner1] !==
                                  undefined
                                    ? matchLiabilities.odds.pnl[runner1]
                                    : parseFloat(oddMatchLiablity)) < 0
                                    ? "text-red"
                                    : "text-green"
                                }`}
                              >
                                {parseFloat(
                                  matchLiabilities?.odds?.pnl?.[runner1] || 0
                                ) + parseFloat(oddMatchLiablity || 0)}
                              </span>
                            </h5>

                            <div
                              className="d-flex"
                              style={{
                                color: themeColors["--dark-theme-white-color"],
                              }}
                            >
                              <span
                                className={`${
                                  pr === 1
                                    ? "d-block text-green"
                                    : pr === 2
                                    ? "d-block text-red"
                                    : pr === 3
                                    ? "d-block text-red"
                                    : pr === 4
                                    ? "d-block text-green"
                                    : "d-none"
                                }`}
                              >
                                {"=>"}
                                {pr === 3
                                  ? -money
                                  : pr === 4
                                  ? money
                                  : pr === 1
                                  ? profit
                                  : -profit}
                              </span>

                              {back1
                                .slice()
                                .reverse()
                                .map((bc, index) => (
                                  <div
                                    className={`fs-6 py-2 h-100 text-center cursor-pointer ${
                                      index < back1?.length - 1
                                        ? "bgSecondary dnone"
                                        : "bgInfo"
                                    }`}
                                    onClick={() => {
                                      showModal();
                                      handleShow();
                                      setbackActive(1);
                                      setlayActive(3);
                                      setSelectedPrice(bc.price);
                                      setPr(1);
                                      setSelectedId(selectionid1);
                                      setRunner(runner1);
                                      setSide("Back");
                                    }}
                                    style={{
                                      width: isLargeScreen ? "4rem" : "3.2rem",
                                      borderLeft: "1px solid #c7c8ca",
                                      borderLeft: "1px solid #c7c8ca",
                                    }}
                                  >
                                    {bc.price}
                                  </div>
                                ))}

                              {lay1.map((bc, index) => (
                                <div
                                  className={`fs-6 py-2 h-100 text-center cursor-pointer ${
                                    index === 0
                                      ? "bg-pink1"
                                      : "bgSecondary dnone"
                                  }`}
                                  onClick={() => {
                                    showModal();
                                    handleShow();
                                    setlayActive(4);
                                    setbackActive(0);
                                    setSelectedPrice(bc.price);
                                    setPr(2);
                                    setSelectedId(selectionid1);
                                    setRunner(runner1);
                                    setSide("Lay");
                                  }}
                                  style={{
                                    width: isLargeScreen ? "4rem" : "3.2rem",
                                    borderLeft: "1px solid #c7c8ca",
                                    borderLeft: "1px solid #c7c8ca",
                                  }}
                                >
                                  {bc.price}
                                </div>
                              ))}
                            </div>
                          </div>

                          <div className="betting-row d-flex flex-md-row justify-content-between align-items-md-center p-0">
                            <h5
                              className="my-auto fs-4 text-wrap run ps-2 m-0"
                              id={selectionid2}
                              style={{ color: themeColors["--text-table"] }}
                            >
                              {runner2}
                              <span
                                className={`${
                                  (matchLiabilities?.odds?.pnl?.[runner2] !==
                                  undefined
                                    ? matchLiabilities.odds.pnl[runner2]
                                    : parseFloat(oddMatchLiablity)) < 0
                                    ? "text-red"
                                    : "text-green"
                                }`}
                              >
                                {parseFloat(
                                  matchLiabilities?.odds?.pnl?.[runner2] || 0
                                ) + parseFloat(oddMatchLiablity || 0)}
                              </span>
                            </h5>

                            <div
                              className="d-flex"
                              style={{
                                color: themeColors["--dark-theme-white-color"],
                              }}
                            >
                              <span
                                className={`${
                                  pr === 3
                                    ? "d-block text-green"
                                    : pr === 4
                                    ? "d-block text-red"
                                    : pr === 1
                                    ? "d-block text-red"
                                    : pr === 2
                                    ? "d-block text-green"
                                    : "d-none"
                                }`}
                              >
                                {"=>"}
                                {pr === 1
                                  ? -money
                                  : pr === 2
                                  ? money
                                  : pr === 3
                                  ? profit
                                  : -profit}
                              </span>

                              {back2
                                .slice()
                                .reverse()
                                .map((bc, index) => (
                                  <div
                                    className={`fs-6 py-2 h-100 text-center cursor-pointer ${
                                      index < back2?.length - 1
                                        ? "bgSecondary dnone"
                                        : "bgInfo"
                                    }`}
                                    onClick={() => {
                                      showModal();
                                      handleShow();
                                      setbackActive(2);
                                      setlayActive(3);
                                      setSelectedPrice(bc.price);
                                      setPr(3);
                                      setSelectedId(selectionid2);
                                      setRunner(runner2);
                                    }}
                                    style={{
                                      width: isLargeScreen ? "4rem" : "3.2rem",
                                      borderLeft: "1px solid #c7c8ca",
                                      borderLeft: "1px solid #c7c8ca",
                                    }}
                                  >
                                    {bc.price}
                                  </div>
                                ))}

                              {lay2.map((bc, index) => (
                                <div
                                  className={`fs-6 py-2 h-100 text-center cursor-pointer ${
                                    index === 0
                                      ? "bg-pink1"
                                      : "bgSecondary dnone"
                                  }`}
                                  onClick={() => {
                                    showModal();
                                    handleShow();
                                    setlayActive(5);
                                    setbackActive(0);
                                    setSelectedPrice(bc.price);
                                    setPr(4);
                                    setSelectedId(selectionid2);
                                    setRunner(runner2);
                                  }}
                                  style={{
                                    width: isLargeScreen ? "4rem" : "3.2rem",
                                    borderLeft: "1px solid #c7c8ca",
                                    borderLeft: "1px solid #c7c8ca",
                                  }}
                                >
                                  {bc.price}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="match-section mb-1"
                        style={{
                          color: themeColors["--dark-theme-color-navbar"],
                        }}
                      >
                        <div
                          className="match-header align-items-end h-auto"
                          style={{ borderBottom: "1px solid #d3cece" }}
                        >
                          <div
                            style={{
                              backgroundColor: themeColors["--bg-secondary85"],
                              marginTop: isLargeScreen ? "0px" : "3px",
                              padding: "5px 10px",
                            }}
                            className="d-flex mb-0 flex-lg-row flex-row flex-md-row align-items-baseline"
                          >
                            <p
                              style={{
                                color: themeColors["--dark-theme-color-navbar"],
                              }}
                              className=" me-3 d-flex fw-bold mb-0 rad bett"
                            >
                              BOOKEMAKER
                            </p>
                            {/* <p
                              className="btn mt-0 btn-success py-1 rounded-0 disabled ms-auto"
                            >
                              Cashout
                            </p> */}
                          </div>

                          <div
                            className="d-flex"
                            style={{
                              height: "2.1rem",
                              marginRight: isLargeScreen ? "8rem" : "0rem",
                            }}
                          >
                            <p
                              className="d-flex gap-1 fs-7 ps-2 me-5 my-auto mb-0 fszz fw-bold"
                              style={{ color: themeColors["--text-info"] }}
                            >
                              <span
                                className="fw-bold"
                                style={{ color: themeColors["--text-info"] }}
                              >
                                Min:{minOdds} <span>|</span>{" "}
                              </span>{" "}
                              Max:{maxOdds}
                            </p>
                            <p
                              className="fs-6 mb-0 px-0 ms-auto ms-auto bgInfo text-center"
                              style={{}}
                            >
                              Back
                            </p>
                            <p className="fs-6 px-xl-3 px-0 mb-0 bg-pink1">
                              Lay
                            </p>
                          </div>
                        </div>

                        <div className="betting-options d-flex flex-column">
                          <div
                            className="betting-row d-flex flex-md-row justify-content-between align-items-center p-0"
                            style={{ borderBottom: "1px solid #c1bdbd" }}
                          >
                            <h5
                              className="my-auto fs-4 text-wrap run ps-2 m-0"
                              id={selectionid1}
                              style={{ color: themeColors["--text-table"] }}
                            >
                              {runner1}
                            </h5>

                            <div
                              className="d-flex"
                              style={{
                                color: themeColors["--dark-theme-white-color"],
                              }}
                            >
                              <span
                                className={`${
                                  pr === 5
                                    ? "d-block text-green"
                                    : pr === 6
                                    ? "d-block text-red"
                                    : pr === 7
                                    ? "d-block text-red"
                                    : pr === 8
                                    ? "d-block text-green"
                                    : "d-none"
                                }`}
                              >
                                {"=>"}
                                {/* {pr===7 ?-money : pr===8 ? money : pr === 5 ? profit : -profit} */}
                              </span>
                              SUSPENDED
                              {/* 
                            {back1.slice().reverse().map((bc, index) => (
                              <div
                                className={`fs-6 py-2 h-100 text-center cursor-pointer ${
                                  index < back1.length - 1
                                    ? "bgSecondary dnone"
                                    : "bgInfo"
                                }`}
                                onClick={() => {
                                  setbackActive(1);
                                  setlayActive(3);
                                  setSelectedPrice(bc.price);
                                  setPr(1);
                                  setSelectedId(selectionid1);
                                  setRunner(runner1);
                                  setSide('Back');
                                  setSelectedBet(0)
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))}

                        

                            {lay1.map((bc, index) => (
                              <div
                                className={`fs-6 py-2 h-100 text-center cursor-pointer ${
                                  index === 0 ? "bg-pink1" : "bgSecondary dnone"
                                }`}
                                onClick={() => {
                                  setlayActive(4);
                                  setbackActive(0);
                                  setSelectedPrice(bc.price);
                                  setPr(2);
                                  setSelectedId(selectionid1);
                                  setRunner(runner1);
                                  setSide('Lay');
                                  setSelectedBet(0);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>  
                            ))} */}
                            </div>
                          </div>

                          <div className="betting-row d-flex flex-md-row justify-content-between align-items-md-center p-0">
                            <h5
                              className="my-auto fs-4 text-wrap run ps-2 m-0"
                              id={selectionid2}
                              style={{ color: themeColors["--text-table"] }}
                            >
                              {runner2}
                            </h5>

                            <div
                              className="d-flex  gap-1"
                              style={{
                                color: themeColors["--dark-theme-white-color"],
                              }}
                            >
                              <span
                                className={`${
                                  pr === 7
                                    ? "d-block text-green"
                                    : pr === 8
                                    ? "d-block text-red"
                                    : pr === 5
                                    ? "d-block text-red"
                                    : pr === 6
                                    ? "d-block text-green"
                                    : "d-none"
                                }`}
                              >
                                {"=>"}
                                {/* {pr===5 ? -money : pr===6 ? -money : pr === 7 ? profit : -profit } */}
                              </span>
                              SUSPENDED
                              {/*                        
                            {back2.slice().reverse().map((bc, index) => (
                              <div
                                className={`fs-6 py-2 h-100 text-center cursor-pointer ${
                                  index < back2.length - 1
                                    ? "bgSecondary dnone"
                                    : "bgInfo"
                                }`}
                                onClick={() => {
                                  setbackActive(2);
                                  setlayActive(3);
                                  setSelectedPrice(bc.price);
                                  setPr(3);
                                  setSelectedId(selectionid2);
                                  setRunner(runner2);
                                  setSelectedBet(0);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))}
                            
                            {lay2.map((bc, index) => (
                              <div
                                className={`fs-6 py-2 h-100 text-center cursor-pointer ${
                                  index === 0 ? "bg-pink1" : "bgSecondary dnone"
                                }`}
                                onClick={() => {
                                  setlayActive(5);
                                  setbackActive(0);
                                  setSelectedPrice(bc.price);
                                  setPr(4);
                                  setSelectedId(selectionid2);
                                  setRunner(runner2);
                                  setSelectedBet(0);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))} */}
                            </div>
                          </div>
                        </div>

                        {/* betting back div */}
                        {/* {backActive !== 0 && (
                        <div style={{ backgroundColor: "#052e36", padding: "15px", color: themeColors['--dark-theme-color-navbar'], borderRadius: "5px", width: "100%" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-backbtn'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >
                            BACK
                          </button>
                          <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                            Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                          </div>
                          <div    style={{ display: "flex", alignItems: "center" }  }>
                            <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                            <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                          </div>
                        </div>
                        
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                          <div  className="w-25" style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                                className="homebet_set"
                                style={{ color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handlelayChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={selectedPrice}
                                onChange={(e) => setSelectedPrice(e.target.value)}
                                className="homebet_set"
                                style={{ color: themeColors['--dark-theme-color-navbar'], border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                                className="homebet_set"
                                style={{ color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handlelayChange(1)}
                              >+</button>
                            </div>
                          </div>
                          <div  className="w-25" style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                                className="homebet_set"
                                style={{ color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handleChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={money}
                                onChange={(e) => setMoney(e.target.value)}
                                className="homebet_set"
                                style={{ color: themeColors['--dark-theme-color-navbar'], border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                                className="homebet_set"
                                style={{ color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handleChange(1)}
                              >+</button>
                            </div>
                          </div>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(100)}
                          >+ 100</button>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(200)}
                          >+ 200</button>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(500)}
                          >+ 500</button>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(1000)}
                          >+ 1k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(5000)}
                          >+ 5k</button>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(10000)}
                          >+ 10k</button>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(25000)}
                          >+ 25k</button>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(50000)}
                          >+ 50k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button style={{ backgroundColor: themeColors['--dark-theme-data-min'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }} onClick={()=>setMoney(minOdds)}>Min</button>
                          <button style={{ backgroundColor: themeColors['--dark-theme-dark-blue-bm'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }} onClick={()=>setMoney(maxOdds)}>Max</button>
                          <button style={{ backgroundColor: themeColors['--dark-theme-data-stake'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-clear'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setMoney(0);
                              setPr(0);
                            }}
                          >Clear</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                          <button 
                            style={{ background: themeColors['--dark-theme-data-cancel'], color: themeColors['--dark-theme-color-navbar'], padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >Cancel</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-submit'], color: themeColors['--dark-theme-color-navbar'], padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => handleSubmit()}
                          >Submit</button>
                        </div>
                      </div>
                      )}
                         {layActive !== 3 && (
                        <div style={{ backgroundColor: "rgb(29 5 32)", padding: "15px", color: themeColors['--dark-theme-color-navbar'], borderRadius: "5px", width: "100%" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >
                            Lay
                          </button>
                          <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                            Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                          </div>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                            <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                          </div>
                        </div>
                        
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                          <div style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                                style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handlelayChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={selectedPrice}
                                onChange={(e) => setSelectedPrice(e.target.value)}
                                style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                                style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handlelayChange(1)}
                              >+</button>
                            </div>
                          </div>
                          <div style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                                style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handleChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={money}
                                onChange={(e) => setMoney(e.target.value)}
                                style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                                style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handleChange(1)}
                              >+</button>
                            </div>
                          </div>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(100)}
                          >+ 100</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(200)}
                          >+ 200</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(500)}
                          >+ 500</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(1000)}
                          >+ 1k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(5000)}
                          >+ 5k</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(10000)}
                          >+ 10k</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(25000)}
                          >+ 25k</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(50000)}
                          >+ 50k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button style={{ backgroundColor: themeColors['--dark-theme-data-min'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }} onClick={()=>setMoney(minOdds)}>Min</button>
                          <button style={{ backgroundColor: themeColors['--dark-theme-dark-blue-bm'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }} onClick={()=>setMoney(maxOdds)}>Max</button>
                          <button style={{ backgroundColor: themeColors['--dark-theme-data-stake'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-clear'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setMoney(0);
                              setPr(0);
                            }}
                          >Clear</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                          <button 
                            style={{ background: themeColors['--dark-theme-data-cancel'], color: themeColors['--dark-theme-color-navbar'], padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >Cancel</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-submit'], color: themeColors['--dark-theme-color-navbar'], padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => handleSubmit()}
                          >Submit</button>
                        </div>
                      </div>
                      )} */}
                      </div>
                      <div
                        className="match-section mb-1"
                        style={{
                          color: themeColors["--dark-theme-color-navbar"],
                        }}
                      >
                        <div
                          className="match-header align-items-end h-auto"
                          style={{ borderBottom: "1px solid #d3cece" }}
                        >
                          <div
                            style={{
                              backgroundColor: themeColors["--bg-secondary85"],
                              marginTop: isLargeScreen ? "0px" : "3px",
                              padding: "5px 10px",
                            }}
                            className="d-flex mb-0 flex-lg-row flex-row flex-md-row align-items-baseline"
                          >
                            <p
                              style={{
                                color: themeColors["--dark-theme-color-navbar"],
                              }}
                              className=" me-3 d-flex fw-bold mb-0 rad bett"
                            >
                              BM 1ST SET WINNER
                            </p>
                            {/* <p
                              className="btn mt-0 btn-success py-1 rounded-0 disabled ms-auto"
                            >
                              Cashout
                            </p> */}
                          </div>

                          <div
                            className="d-flex"
                            style={{
                              height: "2.1rem",
                              marginRight: isLargeScreen ? "8rem" : "0rem",
                            }}
                          >
                            <p
                              className="d-flex gap-1 fs-7 ps-2 me-5 my-auto mb-0 fszz fw-bold"
                              style={{ color: themeColors["--text-info"] }}
                            >
                              <span
                                className="fw-bold"
                                style={{ color: themeColors["--text-info"] }}
                              >
                                Min:{minOdds} <span>|</span>{" "}
                              </span>{" "}
                              Max:{maxOdds}
                            </p>
                            <p
                              className="fs-6 mb-0 px-0  ms-auto bgInfo text-center"
                              style={{ border: "1px solid #c1bdbd" }}
                            >
                              Back
                            </p>
                            <p
                              className="fs-6 px-xl-3 px-0 mb-0 bg-pink1"
                              style={{ border: "1px solid #c1bdbd" }}
                            >
                              Lay
                            </p>
                          </div>
                        </div>

                        <div className="betting-options d-flex flex-column">
                          <div
                            className="betting-row d-flex flex-md-row justify-content-between align-items-center p-0"
                            style={{ borderBottom: "1px solid #c1bdbd" }}
                          >
                            <h5
                              className="my-auto fs-4 text-wrap run ps-2 m-0"
                              id={selectionid1}
                              style={{ color: themeColors["--text-table"] }}
                            >
                              {runner1}
                            </h5>

                            <div
                              className="d-flex"
                              style={{
                                color: themeColors["--dark-theme-white-color"],
                              }}
                            >
                              <span
                                className={`${
                                  pr === 1
                                    ? "d-block text-green"
                                    : pr === 2
                                    ? "d-block text-green"
                                    : pr === 3 ||
                                      pr === 4 ||
                                      pr === 17 ||
                                      pr === 18
                                    ? "d-block text-red"
                                    : "d-none"
                                }`}
                              >
                                {"=>"}
                                {/* {pr===3 || pr===4 || pr===17 || pr===18 ? -money : profit} */}
                              </span>
                              SUSPENDED
                              {/* 
                            {back1.slice().reverse().map((bc, index) => (
                              <div
                                className={`fs-6 py-2 h-100 text-center cursor-pointer ${
                                  index < back1.length - 1
                                    ? "bgSecondary dnone"
                                    : "bgInfo"
                                }`}
                                onClick={() => {
                                  setbackActive(1);
                                  setlayActive(3);
                                  setSelectedPrice(bc.price);
                                  setPr(1);
                                  setSelectedId(selectionid1);
                                  setRunner(runner1);
                                  setSide('Back');
                                  setSelectedBet(0)
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))}

                        

                            {lay1.map((bc, index) => (
                              <div
                                className={`fs-6 py-2 h-100 text-center cursor-pointer ${
                                  index === 0 ? "bg-pink1" : "bgSecondary dnone"
                                }`}
                                onClick={() => {
                                  setlayActive(4);
                                  setbackActive(0);
                                  setSelectedPrice(bc.price);
                                  setPr(2);
                                  setSelectedId(selectionid1);
                                  setRunner(runner1);
                                  setSide('Lay');
                                  setSelectedBet(0);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))} */}
                            </div>
                          </div>

                          <div className="betting-row d-flex flex-md-row justify-content-between align-items-md-center p-0">
                            <h5
                              className="my-auto fs-4 text-wrap run ps-2 m-0"
                              id={selectionid2}
                              style={{ color: themeColors["--text-table"] }}
                            >
                              {runner2}
                            </h5>

                            <div
                              className="d-flex  gap-1"
                              style={{
                                color: themeColors["--dark-theme-white-color"],
                              }}
                            >
                              <span
                                className={`${
                                  pr === 3
                                    ? "d-block text-green"
                                    : pr === 4
                                    ? "d-block text-green"
                                    : pr === 1 ||
                                      pr === 2 ||
                                      pr === 17 ||
                                      pr === 18
                                    ? "d-block text-red"
                                    : "d-none"
                                }`}
                              >
                                {"=>"}
                                {/* {pr===1 || pr===2 || pr===17 || pr===18 ? -money : profit } */}
                              </span>
                              SUSPENDED
                              {/*                        
                            {back2.slice().reverse().map((bc, index) => (
                              <div
                                className={`fs-6 py-2 h-100 text-center cursor-pointer ${
                                  index < back2.length - 1
                                    ? "bgSecondary dnone"
                                    : "bgInfo"
                                }`}
                                onClick={() => {
                                  setbackActive(2);
                                  setlayActive(3);
                                  setSelectedPrice(bc.price);
                                  setPr(3);
                                  setSelectedId(selectionid2);
                                  setRunner(runner2);
                                  setSelectedBet(0);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))}
                            
                            {lay2.map((bc, index) => (
                              <div
                                className={`fs-6 py-2 h-100 text-center cursor-pointer ${
                                  index === 0 ? "bg-pink1" : "bgSecondary dnone"
                                }`}
                                onClick={() => {
                                  setlayActive(5);
                                  setbackActive(0);
                                  setSelectedPrice(bc.price);
                                  setPr(4);
                                  setSelectedId(selectionid2);
                                  setRunner(runner2);
                                  setSelectedBet(0);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))} */}
                            </div>
                          </div>
                        </div>

                        {/* betting back div */}
                        {/* {backActive !== 0 && (
                        <div style={{ backgroundColor: "#052e36", padding: "15px", color: themeColors['--dark-theme-color-navbar'], borderRadius: "5px", width: "100%" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-backbtn'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >
                            BACK
                          </button>
                          <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                            Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                          </div>
                          <div    style={{ display: "flex", alignItems: "center" }  }>
                            <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                            <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                          </div>
                        </div>
                        
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                          <div  className="w-25" style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                                className="homebet_set"
                                style={{ color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handlelayChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={selectedPrice}
                                onChange={(e) => setSelectedPrice(e.target.value)}
                                className="homebet_set"
                                style={{ color: themeColors['--dark-theme-color-navbar'], border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                                className="homebet_set"
                                style={{ color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handlelayChange(1)}
                              >+</button>
                            </div>
                          </div>
                          <div  className="w-25" style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                                className="homebet_set"
                                style={{ color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handleChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={money}
                                onChange={(e) => setMoney(e.target.value)}
                                className="homebet_set"
                                style={{ color: themeColors['--dark-theme-color-navbar'], border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                                className="homebet_set"
                                style={{ color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handleChange(1)}
                              >+</button>
                            </div>
                          </div>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(100)}
                          >+ 100</button>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(200)}
                          >+ 200</button>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(500)}
                          >+ 500</button>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(1000)}
                          >+ 1k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(5000)}
                          >+ 5k</button>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(10000)}
                          >+ 10k</button>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(25000)}
                          >+ 25k</button>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(50000)}
                          >+ 50k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button style={{ backgroundColor: themeColors['--dark-theme-data-min'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                          <button style={{ backgroundColor: themeColors['--dark-theme-dark-blue-bm'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                          <button style={{ backgroundColor: themeColors['--dark-theme-data-stake'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-clear'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setMoney(0);
                              setPr(0);
                            }}
                          >Clear</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                          <button 
                            style={{ background: themeColors['--dark-theme-data-cancel'], color: themeColors['--dark-theme-color-navbar'], padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >Cancel</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-submit'], color: themeColors['--dark-theme-color-navbar'], padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => handleSubmit()}
                          >Submit</button>
                        </div>
                      </div>
                      )}
                         {layActive !== 3 && (
                        <div style={{ backgroundColor: "rgb(29 5 32)", padding: "15px", color: themeColors['--dark-theme-color-navbar'], borderRadius: "5px", width: "100%" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >
                            Lay
                          </button>
                          <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                            Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                          </div>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                            <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                          </div>
                        </div>
                        
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                          <div style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                                style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handlelayChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={selectedPrice}
                                onChange={(e) => setSelectedPrice(e.target.value)}
                                style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                                style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handlelayChange(1)}
                              >+</button>
                            </div>
                          </div>
                          <div style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                                style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handleChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={money}
                                onChange={(e) => setMoney(e.target.value)}
                                style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                                style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handleChange(1)}
                              >+</button>
                            </div>
                          </div>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(100)}
                          >+ 100</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(200)}
                          >+ 200</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(500)}
                          >+ 500</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(1000)}
                          >+ 1k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(5000)}
                          >+ 5k</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(10000)}
                          >+ 10k</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(25000)}
                          >+ 25k</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(50000)}
                          >+ 50k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button style={{ backgroundColor: themeColors['--dark-theme-data-min'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                          <button style={{ backgroundColor: themeColors['--dark-theme-dark-blue-bm'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                          <button style={{ backgroundColor: themeColors['--dark-theme-data-stake'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-clear'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setMoney(0);
                              setPr(0);
                            }}
                          >Clear</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                          <button 
                            style={{ background: themeColors['--dark-theme-data-cancel'], color: themeColors['--dark-theme-color-navbar'], padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >Cancel</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-submit'], color: themeColors['--dark-theme-color-navbar'], padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => handleSubmit()}
                          >Submit</button>
                        </div>
                      </div>
                      )} */}
                      </div>
                      <div
                        className="match-section mb-1"
                        style={{
                          color: themeColors["--dark-theme-color-navbar"],
                        }}
                      >
                        <div
                          className="match-header align-items-end h-auto"
                          style={{ borderBottom: "1px solid #d3cece" }}
                        >
                          <div
                            style={{
                              backgroundColor: themeColors["--bg-secondary85"],
                              marginTop: isLargeScreen ? "0px" : "3px",
                              padding: "5px 10px",
                            }}
                            className="d-flex mb-0 flex-lg-row flex-row flex-md-row align-items-baseline"
                          >
                            <p
                              style={{
                                color: themeColors["--dark-theme-color-navbar"],
                              }}
                              className=" me-3 d-flex fw-bold mb-0 rad bett"
                            >
                              BM 2ND SET WINNER
                            </p>
                            {/* <p
                              className="btn mt-0 btn-success py-1 rounded-0 disabled ms-auto"
                            >
                              Cashout
                            </p> */}
                          </div>

                          <div
                            className="d-flex"
                            style={{
                              height: "2.1rem",
                              marginRight: isLargeScreen ? "8rem" : "0rem",
                            }}
                          >
                            <p
                              className="d-flex gap-1 fs-7 ps-2 me-5 my-auto mb-0 fszz fw-bold"
                              style={{ color: themeColors["--text-info"] }}
                            >
                              <span
                                className="fw-bold"
                                style={{ color: themeColors["--text-info"] }}
                              >
                                Min:{minOdds} <span>|</span>{" "}
                              </span>{" "}
                              Max:{maxOdds}
                            </p>
                            <p
                              className="fs-6 mb-0 px-0  ms-auto bgInfo text-center"
                              style={{ border: "1px solid #c1bdbd" }}
                            >
                              Back
                            </p>
                            <p
                              className="fs-6 px-xl-3 px-0 mb-0 bg-pink1"
                              style={{ border: "1px solid #c1bdbd" }}
                            >
                              Lay
                            </p>
                          </div>
                        </div>

                        <div className="betting-options d-flex flex-column">
                          <div
                            className="betting-row d-flex flex-md-row justify-content-between align-items-center p-0"
                            style={{ borderBottom: "1px solid #c1bdbd" }}
                          >
                            <h5
                              className="my-auto fs-4 text-wrap run ps-2 m-0"
                              id={selectionid1}
                              style={{ color: themeColors["--text-table"] }}
                            >
                              {runner1}
                            </h5>

                            <div
                              className="d-flex"
                              style={{
                                color: themeColors["--dark-theme-white-color"],
                              }}
                            >
                              <span
                                className={`${
                                  pr === 1
                                    ? "d-block text-green"
                                    : pr === 2
                                    ? "d-block text-green"
                                    : pr === 3 ||
                                      pr === 4 ||
                                      pr === 17 ||
                                      pr === 18
                                    ? "d-block text-red"
                                    : "d-none"
                                }`}
                              >
                                {"=>"}
                                {/* {pr===3 || pr===4 || pr===17 || pr===18 ? -money : profit} */}
                              </span>
                              SUSPENDED
                              {/* 
                            {back1.slice().reverse().map((bc, index) => (
                              <div
                                className={`fs-6 py-2 h-100 text-center cursor-pointer ${
                                  index < back1.length - 1
                                    ? "bgSecondary dnone"
                                    : "bgInfo"
                                }`}
                                onClick={() => {
                                  setbackActive(1);
                                  setlayActive(3);
                                  setSelectedPrice(bc.price);
                                  setPr(1);
                                  setSelectedId(selectionid1);
                                  setRunner(runner1);
                                  setSide('Back');
                                  setSelectedBet(0)
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))}

                        

                            {lay1.map((bc, index) => (
                              <div
                                className={`fs-6 py-2 h-100 text-center cursor-pointer ${
                                  index === 0 ? "bg-pink1" : "bgSecondary dnone"
                                }`}
                                onClick={() => {
                                  setlayActive(4);
                                  setbackActive(0);
                                  setSelectedPrice(bc.price);
                                  setPr(2);
                                  setSelectedId(selectionid1);
                                  setRunner(runner1);
                                  setSide('Lay');
                                  setSelectedBet(0);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))} */}
                            </div>
                          </div>

                          <div className="betting-row d-flex flex-md-row justify-content-between align-items-md-center p-0">
                            <h5
                              className="my-auto fs-4 text-wrap run ps-2 m-0"
                              id={selectionid2}
                              style={{ color: themeColors["--text-table"] }}
                            >
                              {runner2}
                            </h5>

                            <div
                              className="d-flex  gap-1"
                              style={{
                                color: themeColors["--dark-theme-white-color"],
                              }}
                            >
                              <span
                                className={`${
                                  pr === 3
                                    ? "d-block text-green"
                                    : pr === 4
                                    ? "d-block text-green"
                                    : pr === 1 ||
                                      pr === 2 ||
                                      pr === 17 ||
                                      pr === 18
                                    ? "d-block text-red"
                                    : "d-none"
                                }`}
                              >
                                {"=>"}
                                {/* {pr===1 || pr===2 || pr===17 || pr===18 ? -money : profit } */}
                              </span>
                              SUSPENDED
                              {/*                        
                            {back2.slice().reverse().map((bc, index) => (
                              <div
                                className={`fs-6 py-2 h-100 text-center cursor-pointer ${
                                  index < back2.length - 1
                                    ? "bgSecondary dnone"
                                    : "bgInfo"
                                }`}
                                onClick={() => {
                                  setbackActive(2);
                                  setlayActive(3);
                                  setSelectedPrice(bc.price);
                                  setPr(3);
                                  setSelectedId(selectionid2);
                                  setRunner(runner2);
                                  setSelectedBet(0);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))}
                            
                            {lay2.map((bc, index) => (
                              <div
                                className={`fs-6 py-2 h-100 text-center cursor-pointer ${
                                  index === 0 ? "bg-pink1" : "bgSecondary dnone"
                                }`}
                                onClick={() => {
                                  setlayActive(5);
                                  setbackActive(0);
                                  setSelectedPrice(bc.price);
                                  setPr(4);
                                  setSelectedId(selectionid2);
                                  setRunner(runner2);
                                  setSelectedBet(0);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))} */}
                            </div>
                          </div>
                        </div>

                        {/* betting back div */}
                        {/* {backActive !== 0 && (
                        <div style={{ backgroundColor: "#052e36", padding: "15px", color: themeColors['--dark-theme-color-navbar'], borderRadius: "5px", width: "100%" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-backbtn'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >
                            BACK
                          </button>
                          <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                            Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                          </div>
                          <div    style={{ display: "flex", alignItems: "center" }  }>
                            <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                            <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                          </div>
                        </div>
                        
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                          <div  className="w-25" style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                                className="homebet_set"
                                style={{ color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handlelayChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={selectedPrice}
                                onChange={(e) => setSelectedPrice(e.target.value)}
                                className="homebet_set"
                                style={{ color: themeColors['--dark-theme-color-navbar'], border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                                className="homebet_set"
                                style={{ color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handlelayChange(1)}
                              >+</button>
                            </div>
                          </div>
                          <div  className="w-25" style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                                className="homebet_set"
                                style={{ color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handleChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={money}
                                onChange={(e) => setMoney(e.target.value)}
                                className="homebet_set"
                                style={{ color: themeColors['--dark-theme-color-navbar'], border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                                className="homebet_set"
                                style={{ color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handleChange(1)}
                              >+</button>
                            </div>
                          </div>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(100)}
                          >+ 100</button>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(200)}
                          >+ 200</button>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(500)}
                          >+ 500</button>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(1000)}
                          >+ 1k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(5000)}
                          >+ 5k</button>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(10000)}
                          >+ 10k</button>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(25000)}
                          >+ 25k</button>
                          <button 
                            className="homebet_set"
                            style={{ color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(50000)}
                          >+ 50k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button style={{ backgroundColor: themeColors['--dark-theme-data-min'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                          <button style={{ backgroundColor: themeColors['--dark-theme-dark-blue-bm'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                          <button style={{ backgroundColor: themeColors['--dark-theme-data-stake'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-clear'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setMoney(0);
                              setPr(0);
                            }}
                          >Clear</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                          <button 
                            style={{ background: themeColors['--dark-theme-data-cancel'], color: themeColors['--dark-theme-color-navbar'], padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >Cancel</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-submit'], color: themeColors['--dark-theme-color-navbar'], padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => handleSubmit()}
                          >Submit</button>
                        </div>
                      </div>
                      )}
                         {layActive !== 3 && (
                        <div style={{ backgroundColor: "rgb(29 5 32)", padding: "15px", color: themeColors['--dark-theme-color-navbar'], borderRadius: "5px", width: "100%" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >
                            Lay
                          </button>
                          <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                            Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                          </div>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                            <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                          </div>
                        </div>
                        
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                          <div style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                                style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handlelayChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={selectedPrice}
                                onChange={(e) => setSelectedPrice(e.target.value)}
                                style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                                style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handlelayChange(1)}
                              >+</button>
                            </div>
                          </div>
                          <div style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                                style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handleChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={money}
                                onChange={(e) => setMoney(e.target.value)}
                                style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                                style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handleChange(1)}
                              >+</button>
                            </div>
                          </div>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(100)}
                          >+ 100</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(200)}
                          >+ 200</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(500)}
                          >+ 500</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(1000)}
                          >+ 1k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(5000)}
                          >+ 5k</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(10000)}
                          >+ 10k</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(25000)}
                          >+ 25k</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-set2'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(50000)}
                          >+ 50k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button style={{ backgroundColor: themeColors['--dark-theme-data-min'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                          <button style={{ backgroundColor: themeColors['--dark-theme-dark-blue-bm'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                          <button style={{ backgroundColor: themeColors['--dark-theme-data-stake'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-clear'], color: themeColors['--dark-theme-color-navbar'], padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setMoney(0);
                              setPr(0);
                            }}
                          >Clear</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                          <button 
                            style={{ background: themeColors['--dark-theme-data-cancel'], color: themeColors['--dark-theme-color-navbar'], padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >Cancel</button>
                          <button 
                            style={{ backgroundColor: themeColors['--dark-theme-data-submit'], color: themeColors['--dark-theme-color-navbar'], padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => handleSubmit()}
                          >Submit</button>
                        </div>
                      </div>
                      )} */}
                      </div>
                    </div>

                    <div className="bets-container d-flex flex-column betTv  gap-1">
                      <div className="d-none d-lg-block position-relative pl-1 ">
                        <div
                          className="py-1 px-2 cursor-pointer d-flex justify-content-between"
                          style={{
                            backgroundColor: themeColors["--bg-secondary"],
                          }}
                          onClick={() => setPlay(!play)}
                        >
                          <div>
                            <span>
                              {" "}
                              <i
                                className="bi bi-broadcast fs-16"
                                style={{ color: "#DC3545" }}
                              ></i>
                            </span>
                            <span> Watch Live Match</span>
                          </div>
                          <div>
                            <button className="live-stream-button ng-star-inserted">
                              {" "}
                              Watch Live{" "}
                            </button>
                          </div>
                        </div>

                        {play && (
                          <iframe
                            title="Live TV"
                            className="border w-100 h-75"
                            src={`https://5por-tt1.top/directstreaming.php?chid=${channel}`}
                            allowFullScreen
                            referrerPolicy="strict-origin-when-cross-origin"
                            sandbox="allow-same-origin allow-scripts"
                          ></iframe>
                        )}
                      </div>

                      <div
                        className="mt-3 mt-lg-0 ms-0 ms-lg-2 mb-4  h-100"
                        style={{
                          maxHeight: "100vh",
                          height: `${betData?.length * 6}vh`,
                          backgroundColor:
                            themeColors["--dark-theme-color-navbar"],
                        }}
                      >
                        {/* <div
                          className="m-0 px-2 py-1 bett"
                          style={{
                            background:
                              themeColors['--bg-secondary'],
                            color: themeColors['--dark-theme-color'],
                          }}
                        >
                          Live Match
                        </div>
                        {new Date() >= new Date(startTime) && (
                          <div className="mb-1">
                            <div style={{ width: '338px' }}>
                              <div style={{ width: '338px' }}>
                                <video width="100%" controls>
                                  <source src="your-video-url.mp4" type="video/mp4" />
                                  Your browser does not support the video tag.
                                </video>
                              </div>

                            </div>
                          </div>
                        )} */}

                        {/* Match ODDS */}
                        {/* betting back div */}
                        {isLargeScreen && (
                          <div>
                            {backActive !== 0 && (
                              <>
                                <div
                                  className="m-0 mt-1 px-2 py-1 bett"
                                  style={{
                                    background: themeColors["--bg-secondary"],
                                    color: themeColors["--dark-theme-color"],
                                  }}
                                >
                                  Place Bet
                                </div>
                                <div
                                  style={{
                                    backgroundColor: "#72bbef",
                                    color:
                                      themeColors["--dark-theme-color-navbar"],
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  ></div>

                                  <table style={{ width: "100%" }}>
                                    <thead
                                      style={{
                                        backgroundColor:
                                          themeColors["--bg-sidebar"],
                                      }}
                                    >
                                      <tr>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          {" "}
                                          (Bet for){" "}
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          Odds
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          Stake
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          <div>Profit:</div>
                                        </td>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        style={{
                                          borderBottom:
                                            "1px solid var(--table-border) !important",
                                        }}
                                      >
                                        <td style={{ padding: "5px" }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              paddingLeft: "5px",
                                              color: themeColors["--text-body"],
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {runner}
                                          </div>
                                        </td>
                                        <td style={{ padding: "5px" }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "24px",
                                              paddingLeft: "5px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={selectedPrice}
                                              onChange={(e) =>
                                                setSelectedPrice(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "12px",
                                                width: "27px",
                                              }}
                                            />
                                            <div>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-sidebar"],
                                                  color:
                                                    themeColors["--text-body"],
                                                  width: "20px",
                                                  border: "none",
                                                  fontSize: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                }}
                                                onClick={() =>
                                                  handlelayChange(0)
                                                }
                                              >
                                                <IoIosArrowUp />
                                              </button>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-sidebar"],
                                                  color:
                                                    themeColors["--text-body"],
                                                  width: "20px",
                                                  border: "none",
                                                  fontSize: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                }}
                                                onClick={() =>
                                                  handlelayChange(1)
                                                }
                                              >
                                                <IoIosArrowDown />
                                              </button>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "24px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={money}
                                              onChange={(e) =>
                                                setMoney(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "32px",
                                              }}
                                            />
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            padding: "5px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              paddingRight: "5px",
                                              color: themeColors["--text-body"],
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {(
                                              money *
                                              (selectedPrice - 1)
                                            ).toFixed(1)}
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>

                                  <div
                                    style={{
                                      display: "grid",
                                      paddingLeft: "5px",
                                      paddingRight: "5px",
                                      gridTemplateColumns: "repeat(5, 1fr)",
                                      gap: "2px",
                                      marginBottom: "2px",
                                    }}
                                  >
                                    {gameButtons.map((btn) => (
                                      <button
                                        key={btn.id}
                                        className="homebet_set"
                                        style={{
                                          color: themeColors["--text-sidebar"],
                                          padding: "5px 0",
                                          border: "none",
                                          fontWeight: "bold",
                                        }}
                                        onClick={() => setMoney(btn.value)}
                                      >
                                        + {btn.label}
                                      </button>
                                    ))}
                                  </div>

                                  <div
                                    style={{
                                      display: "grid",
                                      padding: "2px 5px 4px 5px",
                                      gridTemplateColumns: "repeat(4, 1fr)",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    <button
                                      style={{
                                        backgroundColor: "transparent",
                                        color: "#0d6efd",
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        setMoney(0);
                                        setPr(0);
                                      }}
                                    >
                                      Clear
                                    </button>
                                    <button
                                      style={{
                                        backgroundColor:
                                          themeColors["--bg-info"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        handleShowV();
                                      }}
                                    >
                                      Edit
                                    </button>

                                    <button
                                      style={{
                                        background: themeColors["--bg-danger"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        setbackActive(0);
                                        setlayActive(3);
                                        setMoney(0);
                                        setPr(0);
                                      }}
                                    >
                                      Reset
                                    </button>
                                    <button
                                      style={{
                                        background: themeColors["--bg-success"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => handleSubmit()}
                                    >
                                      Submit
                                    </button>
                                  </div>
                                </div>
                              </>
                            )}
                            {layActive !== 3 && (
                              <>
                                <div
                                  className="m-0 mt-1 px-2 py-1 bett"
                                  style={{
                                    background: themeColors["--bg-secondary"],
                                    color: themeColors["--dark-theme-color"],
                                  }}
                                >
                                  Place Bet
                                </div>
                                <div
                                  style={{
                                    backgroundColor: "#faa9ba",
                                    color:
                                      themeColors["--dark-theme-color-navbar"],
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  ></div>

                                  <table style={{ width: "100%" }}>
                                    <thead
                                      style={{
                                        backgroundColor:
                                          themeColors["--bg-sidebar"],
                                      }}
                                    >
                                      <tr>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          {" "}
                                          (Bet for){" "}
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          Odds
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          Stake
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          <div>Profit:</div>
                                        </td>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        style={{
                                          borderBottom:
                                            "1px solid var(--table-border) !important",
                                        }}
                                      >
                                        <td style={{ padding: "5px" }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              paddingLeft: "5px",
                                              color: themeColors["--text-body"],
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {runner}
                                          </div>
                                        </td>
                                        <td style={{ padding: "5px" }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "24px",
                                              paddingLeft: "5px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={selectedPrice}
                                              onChange={(e) =>
                                                setSelectedPrice(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "12px",
                                                width: "27px",
                                              }}
                                            />
                                            <div>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-sidebar"],
                                                  color:
                                                    themeColors["--text-body"],
                                                  width: "20px",
                                                  border: "none",
                                                  fontSize: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                }}
                                                onClick={() =>
                                                  handlelayChange(0)
                                                }
                                              >
                                                <IoIosArrowUp />
                                              </button>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-sidebar"],
                                                  color:
                                                    themeColors["--text-body"],
                                                  width: "20px",
                                                  border: "none",
                                                  fontSize: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                }}
                                                onClick={() =>
                                                  handlelayChange(1)
                                                }
                                              >
                                                <IoIosArrowDown />
                                              </button>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "24px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={money}
                                              onChange={(e) =>
                                                setMoney(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "32px",
                                              }}
                                            />
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            padding: "5px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              paddingRight: "5px",
                                              color: themeColors["--text-body"],
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {(
                                              money *
                                              (selectedPrice - 1)
                                            ).toFixed(1)}
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>

                                  <div
                                    style={{
                                      display: "grid",
                                      paddingLeft: "5px",
                                      paddingRight: "5px",
                                      gridTemplateColumns: "repeat(5, 1fr)",
                                      gap: "2px",
                                      marginBottom: "2px",
                                    }}
                                  >
                                    {gameButtons.map((btn) => (
                                      <button
                                        key={btn.id}
                                        className="homebet_set"
                                        style={{
                                          color: themeColors["--text-sidebar"],
                                          padding: "5px 0",
                                          border: "none",
                                          fontWeight: "bold",
                                        }}
                                        onClick={() => setMoney(btn.value)}
                                      >
                                        + {btn.label}
                                      </button>
                                    ))}
                                  </div>

                                  <div
                                    style={{
                                      display: "grid",
                                      padding: "2px 5px 4px 5px",
                                      gridTemplateColumns: "repeat(4, 1fr)",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    <button
                                      style={{
                                        backgroundColor: "transparent",
                                        color: "#0d6efd",
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        setMoney(0);
                                        setPr(0);
                                      }}
                                    >
                                      Clear
                                    </button>
                                    <button
                                      style={{
                                        backgroundColor:
                                          themeColors["--bg-info"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        handleShowV();
                                      }}
                                    >
                                      Edit
                                    </button>

                                    <button
                                      style={{
                                        background: themeColors["--bg-danger"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        setbackActive(0);
                                        setlayActive(3);
                                        setMoney(0);
                                        setPr(0);
                                      }}
                                    >
                                      Reset
                                    </button>
                                    <button
                                      style={{
                                        background: themeColors["--bg-success"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => handleSubmit()}
                                    >
                                      Submit
                                    </button>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        )}
                        {/* /Match ODDS */}

                        {/* SmallScreen Match ODDS */}
                        {/* betting back div */}
                        {!isLargeScreen && (
                          <div>
                            {backActive !== 0 && (
                              <Offcanvas
                                show={show}
                                onHide={handleClose}
                                placement="top"
                                style={{
                                  height: "45vh",
                                  background: "transparent",
                                }}
                              >
                                <Offcanvas.Header
                                  closeButton
                                  style={{
                                    backgroundColor:
                                      themeColors["--bg-primary"],
                                    padding: "10px",
                                    color: themeColors["--text-primary"],
                                  }}
                                >
                                  <Offcanvas.Title className="my-0">
                                    Place Bet
                                  </Offcanvas.Title>
                                </Offcanvas.Header>
                                <Offcanvas.Body className="p-0">
                                  <>
                                    <div
                                      className="px-3"
                                      style={{
                                        backgroundColor: "#72bbef",
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        width: "100%",
                                      }}
                                    >
                                      <div
                                        style={{
                                          paddingTop: "5px",
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                        }}
                                      >
                                        <div className="text-dark">
                                          {runner}
                                        </div>
                                        <div className="text-dark">
                                          Profit:{" "}
                                          {(
                                            money *
                                            (selectedPrice - 1)
                                          ).toFixed(1)}
                                        </div>
                                      </div>
                                      <div
                                        className="row mx-1 py-2"
                                        style={{ backgroundColor: "#ffffff45" }}
                                      >
                                        <div className="col-lg-6 col-6 mb-0 px-1">
                                          <div>
                                            <h6 className="text-center my-0 text-dark">
                                              Odds
                                            </h6>
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "28px",
                                            }}
                                          >
                                            <button
                                              style={{
                                                backgroundColor:
                                                  "var(--bg-secondary)",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                width: "22px",
                                                border: "none",
                                                fontSize: "13px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "0px",
                                              }}
                                              onClick={() => handlelayChange(0)}
                                            >
                                              −
                                            </button>
                                            <input
                                              type="text"
                                              value={selectedPrice}
                                              onChange={(e) =>
                                                setSelectedPrice(e.target.value)
                                              }
                                              style={{
                                                backgroundColor: "#fff",
                                                color:
                                                  "var(--dark-theme-white-color)",
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "84px",
                                              }}
                                            />
                                            <button
                                              style={{
                                                backgroundColor:
                                                  "var(--bg-secondary)",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                width: "22px",
                                                border: "none",
                                                fontSize: "13px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "0px",
                                              }}
                                              onClick={() => handlelayChange(1)}
                                            >
                                              +
                                            </button>
                                          </div>
                                        </div>
                                        <div className="col-lg-6 col-6 mb-0 px-1">
                                          <div>
                                            <h6 className="text-center my-0 text-dark">
                                              Amount
                                            </h6>
                                          </div>

                                          <div
                                            style={{
                                              display: "flex",
                                              height: "28px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={money}
                                              onChange={(e) =>
                                                setMoney(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "1px solid black",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "32px",
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        style={{
                                          display: "grid",
                                          paddingLeft: "5px",
                                          paddingRight: "5px",
                                          gridTemplateColumns: "repeat(5, 1fr)",
                                          gap: "2px",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        {gameButtons.map((btn) => (
                                          <button
                                            key={btn.id}
                                            className="homebet_setSm"
                                            style={{
                                              color:
                                                themeColors["--text-secondary"],
                                              padding: "5px 0",
                                              border: "none",
                                              fontWeight: "bold",
                                            }}
                                            onClick={() => setMoney(btn.value)}
                                          >
                                            + {btn.label}
                                          </button>
                                        ))}
                                      </div>

                                      <div
                                        style={{
                                          display: "grid",
                                          padding: "2px 5px 4px 5px",
                                          gridTemplateColumns: "repeat(4, 1fr)",
                                          marginBottom: "8px",
                                        }}
                                      >
                                        <button
                                          style={{
                                            backgroundColor: "transparent",
                                            color: "#0d6efd",
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            setMoney(0);
                                            setPr(0);
                                          }}
                                        >
                                          Clear
                                        </button>
                                        <button
                                          style={{
                                            backgroundColor:
                                              themeColors["--bg-info"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            handleShowV();
                                          }}
                                        >
                                          Edit
                                        </button>

                                        <button
                                          style={{
                                            background:
                                              themeColors["--bg-danger"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            setbackActive(0);
                                            setlayActive(3);
                                            setMoney(0);
                                            setPr(0);
                                          }}
                                        >
                                          Reset
                                        </button>
                                        <button
                                          style={{
                                            background:
                                              themeColors["--bg-success"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            handleSubmit();
                                            setbackActive(0);
                                          }}
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </div>
                                  </>
                                </Offcanvas.Body>
                              </Offcanvas>
                            )}
                            {layActive !== 3 && (
                              <Offcanvas
                                show={show}
                                onHide={handleClose}
                                placement="top"
                                style={{
                                  height: "45vh",
                                  background: "transparent",
                                }}
                              >
                                <Offcanvas.Header
                                  closeButton
                                  style={{
                                    backgroundColor:
                                      themeColors["--bg-primary"],
                                    padding: "10px",
                                    color: themeColors["--text-primary"],
                                  }}
                                >
                                  <Offcanvas.Title className="my-0">
                                    Place Bet
                                  </Offcanvas.Title>
                                </Offcanvas.Header>
                                <Offcanvas.Body className="p-0">
                                  <>
                                    <div
                                      className="px-3"
                                      style={{
                                        backgroundColor: "#faa9ba",
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        width: "100%",
                                      }}
                                    >
                                      <div
                                        style={{
                                          paddingTop: "5px",
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                        }}
                                      >
                                        <div className="text-dark">
                                          {runner}
                                        </div>
                                        <div className="text-dark">
                                          Profit:{" "}
                                          {(
                                            money *
                                            (selectedPrice - 1)
                                          ).toFixed(1)}
                                        </div>
                                      </div>
                                      <div
                                        className="row mx-1 py-2"
                                        style={{ backgroundColor: "#ffffff45" }}
                                      >
                                        <div className="col-lg-6 col-6 mb-0 px-1">
                                          <div>
                                            <h6 className="text-center my-0 text-dark">
                                              Odds
                                            </h6>
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "28px",
                                            }}
                                          >
                                            <button
                                              style={{
                                                backgroundColor:
                                                  "var(--bg-secondary)",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                width: "22px",
                                                border: "none",
                                                fontSize: "13px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "0px",
                                              }}
                                              onClick={() => handlelayChange(0)}
                                            >
                                              −
                                            </button>
                                            <input
                                              type="text"
                                              value={selectedPrice}
                                              onChange={(e) =>
                                                setSelectedPrice(e.target.value)
                                              }
                                              style={{
                                                backgroundColor: "#fff",
                                                color:
                                                  "var(--dark-theme-white-color)",
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "84px",
                                              }}
                                            />
                                            <button
                                              style={{
                                                backgroundColor:
                                                  "var(--bg-secondary)",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                width: "22px",
                                                border: "none",
                                                fontSize: "13px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "0px",
                                              }}
                                              onClick={() => handlelayChange(1)}
                                            >
                                              +
                                            </button>
                                          </div>
                                        </div>
                                        <div className="col-lg-6 col-6 mb-0 px-1">
                                          <div>
                                            <h6 className="text-center my-0 text-dark">
                                              Amount
                                            </h6>
                                          </div>

                                          <div
                                            style={{
                                              display: "flex",
                                              height: "28px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={money}
                                              onChange={(e) =>
                                                setMoney(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "1px solid black",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "32px",
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        style={{
                                          display: "grid",
                                          paddingLeft: "5px",
                                          paddingRight: "5px",
                                          gridTemplateColumns: "repeat(5, 1fr)",
                                          gap: "2px",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        {gameButtons.map((btn) => (
                                          <button
                                            key={btn.id}
                                            className="homebet_setSm"
                                            style={{
                                              color:
                                                themeColors["--text-secondary"],
                                              padding: "5px 0",
                                              border: "none",
                                              fontWeight: "bold",
                                            }}
                                            onClick={() => setMoney(btn.value)}
                                          >
                                            + {btn.label}
                                          </button>
                                        ))}
                                      </div>

                                      <div
                                        style={{
                                          display: "grid",
                                          padding: "2px 5px 4px 5px",
                                          gridTemplateColumns: "repeat(4, 1fr)",
                                          marginBottom: "8px",
                                        }}
                                      >
                                        <button
                                          style={{
                                            backgroundColor: "transparent",
                                            color: "#0d6efd",
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            setMoney(0);
                                            setPr(0);
                                          }}
                                        >
                                          Clear
                                        </button>
                                        <button
                                          style={{
                                            backgroundColor:
                                              themeColors["--bg-info"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            handleShowV();
                                          }}
                                        >
                                          Edit
                                        </button>

                                        <button
                                          style={{
                                            background:
                                              themeColors["--bg-danger"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            setbackActive(0);
                                            setlayActive(3);
                                            setMoney(0);
                                            setPr(0);
                                          }}
                                        >
                                          Reset
                                        </button>
                                        <button
                                          style={{
                                            background:
                                              themeColors["--bg-success"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            handleSubmit();
                                            setlayActive(3);
                                          }}
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </div>
                                  </>
                                </Offcanvas.Body>
                              </Offcanvas>
                            )}
                          </div>
                        )}
                        {/* / SmallScreen Match ODDS */}

                        <div
                          className="m-0 mt-1 px-2 py-1 bett"
                          style={{
                            background: themeColors["--bg-secondary"],
                            color: themeColors["--dark-theme-color-navbar"],
                          }}
                        >
                          My Bets
                        </div>

                        <table
                          className="table w-100"
                          style={{ borderCollapse: "collapse" }}
                        >
                          <thead>
                            <tr
                              style={{
                                borderBottom:
                                  "1px solid var(--table-border) !important",
                              }}
                            >
                              <th className="headerColor">Matched Bet</th>
                              <th>ODDS</th>
                              <th>Bet Amount</th>
                              <th>P/L</th>
                            </tr>
                          </thead>

                          <tbody>
                            {betData?.length > 0 ? (
                              betData?.map((bet, index) => (
                                <tr
                                  key={index}
                                  style={{
                                    backgroundColor: "#72bbef",
                                    borderBottom:
                                      "1px solid var(--table-border) !important",
                                  }}
                                >
                                  <td style={{ backgroundColor: "#72bbef" }}>
                                    {bet.runnerName}&nbsp;({bet.type})
                                  </td>
                                  <td style={{ backgroundColor: "#72bbef" }}>
                                    {bet.betprice}
                                  </td>
                                  <td style={{ backgroundColor: "#72bbef" }}>
                                    {bet.betAmount}
                                  </td>
                                  <td style={{ backgroundColor: "#72bbef" }}>
                                    {bet.profit}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                {/* <td className=" text-white bett" onClick={()=> setActive(true)}>Login required</td>
                            <td className=" text-white bett">to view</td>
                            <td className=" text-white bett">bet data</td> */}
                                <td>No bet data</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <GameButtons
                      showV={showV}
                      handleCloseV={handleCloseV}
                      onButtonsChange={handleButtonsChange}
                    />
                  </div>
                </div>
              </div>
              <MarqueeBottom onMenuClick={handleCanvasShow} />
            </div>
          </app-landing-page-new>
        </div>
      </app-root>
    </>
  );
};

export default Tennis;